import { useFeatures } from '@/contexts/root-store-context'
import { observer } from 'mobx-react-lite'
import { ArchiveJobDialogContainer } from '@/features/jobs/ArchiveJobDialog/ArchiveJobDialogContainer'

/**
 * Inner component for JobDialogsHost that renders all job-related dialogs.
 * This component is lazy-loaded to improve performance.
 */
export default observer(function Inner() {
  const { internal } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))

  return (
    <>
      <ArchiveJobDialogContainer vm={internal.archiveJobDialogViewModel} />
    </>
  )
})
